import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = {
  class: "media-list media-list-bordered",
  id: "project_overview"
}
const _hoisted_4 = { class: "media card card-group d-flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 align-self-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-grey-800 text-grey-800 rounded-round border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-hash" })
  ])
], -1)
const _hoisted_6 = { class: "media-body align-self-center" }
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { class: "media card card-group d-flex flex-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 align-self-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-grey-800 text-grey-800 rounded-round border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-office" })
  ])
], -1)
const _hoisted_11 = { class: "media-body align-self-center" }
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = { class: "font-weight-bold" }
const _hoisted_14 = { class: "media card card-group d-flex flex-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 align-self-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-grey-800 text-grey-800 rounded-round border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-mention" })
  ])
], -1)
const _hoisted_16 = { class: "media-body align-self-center" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "" }
const _hoisted_20 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, " Objektnummer: " + _toDisplayString(_ctx.details.pid), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.details.projectName), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.details.p_strasse) + " " + _toDisplayString(_ctx.details.p_hnr), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.details.p_plz) + " " + _toDisplayString(_ctx.details.p_ort), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", {
              href: 'tel:'+_ctx.details.p_tel,
              class: "font-italic"
            }, _toDisplayString(_ctx.details.p_tel), 9, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("a", {
              href: 'mailto:'+_ctx.details.p_email,
              class: "font-italic"
            }, _toDisplayString(_ctx.details.p_email), 9, _hoisted_20)
          ])
        ])
      ])
    ])
  ]))
}